/* Moon Peak — ambient site audio
 * Browsers refuse to start audible playback before a user gesture. There is no
 * flag or workaround for this; it is enforced in the media engine. So we arm on
 * load and start on the first genuine interaction (pointer, key, touch, scroll),
 * fading in rather than cutting in. State persists per visitor.
 */
(function () {
  'use strict';

  var root = document.getElementById('site-audio');
  if (!root) return;

  var audio = root.querySelector('audio');
  var button = root.querySelector('.site-audio__toggle');
  if (!audio || !button) return;

  var STORE_KEY = 'moonpeak:audio';
  var target = Math.min(1, Math.max(0, parseFloat(root.dataset.volume || '0.35')));
  var fadeMs = 1800;

  var unlocked = false;
  var fadeRaf = null;

  function readPref() {
    try {
      var v = localStorage.getItem(STORE_KEY);
      if (v === 'on' || v === 'off') return v;
    } catch (e) {}
    return root.dataset.default === 'off' ? 'off' : 'on';
  }

  function writePref(v) {
    try { localStorage.setItem(STORE_KEY, v); } catch (e) {}
  }

  var pref = readPref();

  function fadeTo(to, ms, done) {
    if (fadeRaf) cancelAnimationFrame(fadeRaf);
    var from = audio.volume;
    var start = performance.now();
    if (ms <= 0 || from === to) {
      audio.volume = to;
      if (done) done();
      return;
    }
    (function step(now) {
      var t = Math.min(1, (now - start) / ms);
      var e = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
      audio.volume = Math.min(1, Math.max(0, from + (to - from) * e));
      if (t < 1) {
        fadeRaf = requestAnimationFrame(step);
      } else {
        fadeRaf = null;
        if (done) done();
      }
    })(start);
  }

  function start() {
    audio.volume = 0;
    var p = audio.play();
    if (p && typeof p.catch === 'function') {
      p.then(function () {
        setState('on');
        fadeTo(target, fadeMs);
      }).catch(function () {
        setState('off', true);
      });
    } else {
      setState('on');
      fadeTo(target, fadeMs);
    }
  }

  function stop() {
    fadeTo(0, 420, function () { audio.pause(); });
    setState('off');
  }

  function setState(state, silent) {
    var on = state === 'on';
    root.classList.toggle('is-playing', on);
    button.setAttribute('aria-pressed', on ? 'true' : 'false');
    button.setAttribute(
      'aria-label',
      (on ? 'Pause' : 'Play') + ' ambient sound' +
      (root.dataset.title ? ' — ' + root.dataset.title : '')
    );
    if (!silent) {
      pref = state;
      writePref(state);
    }
  }

  var GESTURES = ['pointerdown', 'keydown', 'touchstart', 'wheel'];

  function onFirstGesture(e) {
    if (e.type === 'keydown' && (e.key === 'Tab' || e.metaKey || e.ctrlKey || e.altKey)) return;
    disarm();
    unlocked = true;
    if (pref === 'on') start();
  }

  function arm() {
    GESTURES.forEach(function (t) {
      document.addEventListener(t, onFirstGesture, { passive: true });
    });
  }

  function disarm() {
    GESTURES.forEach(function (t) {
      document.removeEventListener(t, onFirstGesture, { passive: true });
    });
  }

  button.addEventListener('click', function () {
    unlocked = true;
    disarm();
    if (root.classList.contains('is-playing')) {
      stop();
    } else {
      start();
    }
  });

  document.addEventListener('visibilitychange', function () {
    if (!unlocked || pref !== 'on') return;
    if (document.hidden) {
      audio.pause();
    } else {
      var p = audio.play();
      if (p && p.catch) p.catch(function () {});
    }
  });

  audio.addEventListener('ended', function () { audio.currentTime = 0; audio.play(); });

  setState(pref, true);
  if (pref === 'on') arm();
})();